// extracted by mini-css-extract-plugin
export var animating = "_2v-3";
export var background = "_2v-6";
export var constrainHeight = "_2v-2";
export var dark = "_2v-4";
export var dropdown = "_2v-1";
export var leave = "_2v-5";
export var option = "_2v-7";
export var root = "_2v-0";